import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const TIP_SIZE = 10;

export const useStyles = makeStyles<
  Theme,
  { zIndex?: number; tipPosition?: number }
>((theme) => ({
  popper: ({ zIndex }) => ({
    zIndex: zIndex || theme.zIndex.tooltip,
    width: 300,
  }),
  card: {
    margin: theme.spacing(2, 0),
    overflow: 'visible',
    position: 'relative',

    '&:before': {
      content: '""',
      display: 'block',
      height: 0,
      position: 'absolute',
      width: 0,
    },
  },
  cardTop: ({ tipPosition }) => ({
    '&:before': {
      borderTop: `${TIP_SIZE}px solid ${theme.palette.common.white}`,
      borderLeft: `${TIP_SIZE}px solid transparent`,
      borderRight: `${TIP_SIZE}px solid transparent`,
      left: tipPosition || '50%',
      bottom: -TIP_SIZE,
      transform: 'translateX(-50%)',
    },
  }),
  cardRight: ({ tipPosition }) => ({
    '&:before': {
      borderBottom: `${TIP_SIZE}px solid transparent`,
      borderTop: `${TIP_SIZE}px solid transparent`,
      borderRight: `${TIP_SIZE}px solid ${theme.palette.common.white}`,
      left: -TIP_SIZE,
      top: tipPosition || '50%',
      transform: 'translateY(-50%)',
    },
  }),
  cardBottom: ({ tipPosition }) => ({
    '&:before': {
      borderBottom: `${TIP_SIZE}px solid ${theme.palette.common.white}`,
      borderRight: `${TIP_SIZE}px solid transparent`,
      borderLeft: `${TIP_SIZE}px solid transparent`,
      left: tipPosition || '50%',
      top: -TIP_SIZE,
      transform: 'translateX(-50%)',
    },
  }),
  cardLeft: ({ tipPosition }) => ({
    '&:before': {
      borderBottom: `${TIP_SIZE}px solid transparent`,
      borderTop: `${TIP_SIZE}px solid transparent`,
      borderLeft: `${TIP_SIZE}px solid ${theme.palette.common.white}`,
      right: -TIP_SIZE,
      top: tipPosition || '50%',
      transform: 'translateY(-50%)',
    },
  }),
  cardContent: {
    padding: `${theme.spacing(2.5, 3, 2.25, 2)} !important`,
  },
  closeButton: {
    color: theme.palette.grey[500],
    position: 'absolute',
    right: theme.spacing(1.75),
    top: theme.spacing(1.75),
  },
}));
